import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/settings/AddUser.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const AddUser = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    user_name: "",
    email: "",
    role: "User",
    user_status: "Active",
    contact_number: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/admin/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          user_name: form.user_name,
          email: form.email,
          contact_number: form.contact_number,
          role: form.role,
          user_status: form.user_status,
          password: form.password,
        }),
      });

      // ✅ SAFE RESPONSE HANDLING
      const text = await res.text();
      let data;

      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Server returned invalid response");
      }

      if (!res.ok) {
        console.error("SERVER RESPONSE:", data);
        throw new Error(data.message || "Failed to create user");
      }

      // ✅ SUCCESS
      navigate("/admin/settings/users");
    } catch (err) {
      console.error("CREATE USER ERROR:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-user-page">
      <div className="add-user-card">
        <h2>Add New User</h2>
        <p className="subtitle">Create a new user account</p>

        <form onSubmit={handleSubmit}>
          <label>Full Name</label>
          <input
            name="user_name"
            placeholder="Enter full name"
            value={form.user_name}
            onChange={handleChange}
            required
          />

          <label>Email Address</label>
          <input
            name="email"
            type="email"
            placeholder="Enter email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <label>Contact Number</label>
          <input
            name="contact_number"
            placeholder="Enter contact number"
            value={form.contact_number}
            onChange={handleChange}
          />

          <label>Role</label>
          <select name="role" value={form.role} onChange={handleChange}>
            <option>User</option>
            <option>Admin</option>
          </select>

          <label>Status</label>
          <select
            name="user_status"
            value={form.user_status}
            onChange={handleChange}
          >
            <option>Active</option>
            <option>Inactive</option>
          </select>

          <label>Password</label>
          <input
            type="password"
            name="password"
            placeholder="Enter password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <label>Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm password"
            value={form.confirmPassword}
            onChange={handleChange}
            required
          />

          {error && <p className="error">{error}</p>}

          <div className="form-actions">
            <button type="submit" className="primary-btn" disabled={loading}>
              {loading ? "Saving..." : "Save User"}
            </button>

            <button
              type="button"
              className="secondary-btn"
              onClick={() => navigate("/admin/settings/users")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
